import { render, staticRenderFns } from "./EfekLoading.vue?vue&type=template&id=4288385e&scoped=true"
import script from "./EfekLoading.vue?vue&type=script&lang=js"
export * from "./EfekLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4288385e",
  null
  
)

export default component.exports